module.exports = __webpack_public_path__ + "img/custom-metric-display.57f1b59f.svg";